import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useCurrentUser } from "../UserProvider";

export default function AdminRoute() {
  const location = useLocation();
  const { currentUser, loading } = useCurrentUser();

  const token = !!localStorage.getItem('refresh_token');

  if (!token && !loading) {
    return <Navigate to="/login" replace />;
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  if (currentUser && currentUser.onboarding_done === false && !location.pathname.startsWith('/onboarding')) {
    return <Navigate to="/onboarding" replace />;
  }

  if (currentUser && !currentUser.is_admin) {
    return <Navigate to="/jobs" replace />;
  }

  return <Outlet />;
}